module.exports = __webpack_public_path__ + "img/05.a01f52a7.jpg";